module.exports = __webpack_public_path__ + "static/img/channel_search_item_06.88fbb21.png";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/images/worktype/channel_search_item_06.png
// module id = zKz9
// module chunks = 0